/* eslint-disable import/prefer-default-export */
// Local Dev
// export const REST_ENDPOINT = 'http://localhost:3000';
// export const WS_ENDPOINT = 'http://localhost:3001';
// Dev
export const REST_ENDPOINT = 'https://dev.purplevisitsapi.com';
export const WS_ENDPOINT = 'https://wsdev.purplevisitsapi.com';
// Staging
// export const REST_ENDPOINT = 'https://staging.purplevisitsapi.com';
// export const WS_ENDPOINT = 'https://wsstaging.purplevisitsapi.com';
// Prod
// export const REST_ENDPOINT = 'https://prod.purplevisitsapi.com';
// export const WS_ENDPOINT = 'https://wsprod.purplevisitsapi.com';
